export default __webpack_public_path__ + "static/blue-page-background-ef66b3a915dc497091c38cdb9ef69125.png";